import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { ChapterMap } from "@/components/ChapterMap";
import { ChapterFinder } from "@/components/ChapterFinder";

export const ChapterSection = () => {
  const [chapters, setChapters] = useState([]);
  const [selected, setSelected] = useState("");
  const finderRef = useRef(null);

  useEffect(() => {
    api.get("/chapters").then((r) => setChapters(r.data || [])).catch(() => {});
  }, []);

  const handleSelect = (state) => {
    setSelected(state);
    setTimeout(() => {
      finderRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  return (
    <div data-testid="chapter-section">
      <section className="bg-white py-24 sm:py-32">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.3em] font-semibold text-[#D90429]">Our Reach</span>
            <h2 className="font-display text-4xl sm:text-6xl uppercase mt-4 leading-[0.95]">
              The Movement <span className="text-[#D90429]">Map</span>
            </h2>
            <p className="text-slate-600 text-lg mt-5 max-w-2xl mx-auto leading-relaxed">
              Red states have active chapters. Amber states are calling for leaders. Tap any state to find or start a chapter.
            </p>
          </div>
          <ChapterMap chapters={chapters} selected={selected} onSelect={handleSelect} />
        </div>
      </section>

      <div ref={finderRef}>
        <ChapterFinder chapters={chapters} selected={selected} onSelectState={setSelected} />
      </div>
    </div>
  );
};
